import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import InputWrapper from "../../../layout/inputWrapper";
import FileUploader from "../../../reusableComponents/FileUploader2";
import ScrollButton from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/AwasBandhu/UpwardScrollButton";
import { genderData, statesName } from "../../../../TCPForms/data";
import { shallowEqual, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Toast } from "@egovernments/digit-ui-react-components";
import { filterCategory } from "../../land-Use/helpers/helpers";

const ownerEntry = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE",
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT",
  },
};

const SubStep1 = ({
  formData,
  handleSubTabChange,
  setFormData,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  initFormMTDocs,
  userInfo,
}) => {
  const { documents } = useSelector((state) => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const [user, setUser] = useState(null);
  const defaultValues = {
    ...formData,
    department: applicationFlow,
    landInfo: {
      ...formData?.landInfo,
      owners: formData?.landInfo?.owners?.length > 0 ? formData?.landInfo?.owners : [ownerEntry],
    },
    documents: documents,
  };

  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  // const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const updistricts = isDistrictDataLoading
    ? []
    : districtData.map((district) => ({
        label: district.name,
        value: district.name,
        name: district.name,
      }));
  console.log("upDIstricts", updistricts);

  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const isDA = applicationFlow === "DA";
  const { handleSubmit, control, reset, watch, getValues, setValue, trigger } = useForm({ defaultValues });
  const { fields: owners, append: appendOwner, remove: removeOwner } = useFieldArray({
    control,
    name: "landInfo.owners",
  });
  const watchState = (idx) => watch(`landInfo.owners[${idx}].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || formData?.selectedOffice;
  const watchSelectedOffice = isDA ? watchOffice?.split(" ")[0] : watchOffice?.split(",")[1]?.trim();
  const watchUnit = watch("selectedUnit") || formData?.selectedUnit;
  const watchCity = watch("selectedCity") || formData?.selectedCity;
  const filterCities = (unit, masterData) => {
    const result = masterData
      ?.filter((item) => item.Unit === unit)?.[0]
      ?.Cities?.map((item) => {
        return { name: item.City, label: item.City, value: item.City };
      });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData?.location1);
  }, [formData?.location1]);

  const closeToast = () => {
    setShowToast(null);
  };

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        } else if (response?.BPA?.[0]?.department !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`,
          });
          return;
        }
        data = response?.BPA?.filter((item) => item.applicationType === "FORM_LANDUSE")?.[0];
        purchasableData = response?.BPA?.filter((item) => item.applicationType === "FORM_PURCHASABLE_FAR")?.[0];
        console.log(data, "datatata");
        if (data) {
          const uuid = userInfo?.uuid;
          if (uuid) {
            const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
            const userDetail = usersResponse?.user?.[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            setValue("professionalInformation", {
              consultantCategory: filterCategory(userDetail?.roles),
              validupto: userDetail?.pwdExpiryDate,
              name: userDetail?.name,
              mobileNumber: userDetail?.mobileNumber,
              emailId: userDetail?.emailId,
              registrationNumber: userDetail?.registrationNumber,
              registrationArchitectNumber: userDetail?.registrationArchitectNumber,
            });
          }
        }
        Digit.SessionStorage.set("KP_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("selectedOffice", data?.selectedOffice);
        setValue("landInfo.owners[0].name", data?.landInfo?.owners?.[0]?.name);
        setValue("landInfo.owners[0].fatherOrHusbandName", data?.landInfo?.owners?.[0]?.fatherOrHusbandName);
        setValue("landInfo.owners[0].gender", data?.landInfo?.owners?.[0]?.gender);
        setValue("landInfo.owners[0].mobileNumber", data?.landInfo?.owners?.[0]?.mobileNumber);
        setValue("landInfo.owners[0].emailId", data?.landInfo?.owners?.[0]?.emailId);
        setValue("landInfo.owners[0].aadhaarNumber", data?.landInfo?.owners?.[0]?.aadhaarNumber);
        setValue("landInfo.owners[0].correspondenceAddress.state", data?.landInfo?.owners?.[0]?.correspondenceAddress?.state);
        setValue("landInfo.owners[0].correspondenceAddress.address", data?.landInfo?.owners?.[0]?.correspondenceAddress?.address);
        setValue("landInfo.owners[0].correspondenceAddress.town", data?.landInfo?.owners?.[0]?.correspondenceAddress?.town);
        setValue("landInfo.owners[0].correspondenceAddress.pinno", data?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno);

        //setFormData(data);
        setValue("landInfo", data?.landInfo);
        setValue("descriptionOfLand", data?.descriptionOfLand);
        setValue("landAreaDetails", data?.landAreaDetails);
        const mappedOwners = (data?.landInfo?.owners || []).map((owner) => ({
          ...ownerEntry, // ensures all default keys
          ...owner,
          correspondenceAddress: {
            ...ownerEntry.correspondenceAddress,
            ...(owner.correspondenceAddress || {}),
          },
          permanentAddress: {
            ...ownerEntry.permanentAddress,
            ...(owner.permanentAddress || {}),
          },
        }));
        setValue("landInfo.owners", mappedOwners);
        if (data?.documents?.length > 0) {
          initFormMTDocs(data?.documents);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      if (isDA && watchSelectedOffice) {
        const location = watchSelectedOffice;
        const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      } else if (watchUnit && watchCity) {
        const location2 = watchCity;
        const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice]);

  const validateFiles = () => {
    const uploadedDocs = documents?.map((doc) => doc.documentType);
    const isValid = ["signature"].every((doc) => uploadedDocs.includes(doc));
    return isValid;
  };

  const onSubmit = (data) => {
    handleSubTabChange(1, data);
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">FastPAS Id Details</h2>
          </div>
          <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS ID"
                  placeholder="Enter FASTPAS ID."
                  name="fastPASId"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.fastPASId}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("fastPASId"))}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
          <div className="formHeaderContainer">
            <h2 className="formHeading">Verifying Authority</h2>
          </div>
          {isDA ? (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={"Select Development Authority"}
                    inputLabel="Select office"
                    placeholder="Select office"
                    name="selectedOffice"
                    type="searchSelect"
                    defaultValue={formData?.selectedOffice}
                    
                    data={SortingAlphabatically(officesList)}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          ) : (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select Unit"}
                    inputLabel="Select unit"
                    placeholder="Select unit"
                    name="selectedUnit"
                    type="searchSelect"
                    data={SortingAlphabatically(avpUnits)}
                    defaultValue={formData?.selectedUnit || ""}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col>
                {watchUnit ? (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Select City"}
                      inputLabel="Select city"
                      placeholder="Select city"
                      name="selectedCity"
                      type="searchSelect"
                      data={SortingAlphabatically(avpCities)}
                      defaultValue={formData?.selectedCity}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            </Container>
          )}

          <div className="formHeaderContainer" style={{ marginTop: "26px" }}>
            <h2 className="formHeading">{t("Owner/Applicant Details")}</h2>
          </div>

          {owners?.map((owner, index) => (
            <Container className="formInputContainer common-app-form" fluid key={owner.id}>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label="Name"
                    control={control}
                    placeholder="Enter Name"
                    name={`landInfo.owners[${index}].name`}
                    type="textInput"
                    maxLength={30}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="Father Name"
                    placeholder="Enter Father Name"
                    name={`landInfo.owners[${index}].fatherOrHusbandName`}
                    type="textInput"
                    maxLength={30}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={t("Gender")}
                    placeholder={t("Gender")}
                    name={`landInfo.owners[0].gender`}
                    type="searchSelect"
                    data={SortingAlphabatically(genderData)}
                    defaultValue={formData?.landInfo?.owners?.[0]?.gender}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Please select the gender",
                      },
                    }}
                    disabled
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="Mobile Number"
                    placeholder="Enter Mobile Number"
                    name={`landInfo.owners[${index}].mobileNumber`}
                    type="number"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("MobileNo"),
                        message: "Please enter valid mobile no",
                      },
                    }}
                    disabled
                    maxLength={10}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label="E-mail ID"
                    control={control}
                    placeholder="Enter E-mail ID"
                    name={`landInfo.owners[${index}].emailId`}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Email"),
                        message: "Please enter valid email id",
                      },
                    }}
                    disabled
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label="Aadhaar Number"
                    control={control}
                    placeholder="Enter Aadhaar Number"
                    name={`landInfo.owners[${index}].aadhaarNumber`}
                    type="number"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("AadharNo"),
                        message: "Please enter valid Aadhaar no",
                      },
                    }}
                    disabled
                    maxLength={12}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="State"
                    placeholder={"Select State"}
                    defaultValue={owner.correspondenceAddress?.state}
                    name={`landInfo.owners[${index}].correspondenceAddress.state`}
                    type="selectInput"
                    data={statesName}
                    mandatory={true}
                    disabled
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    data={watchState(index) === "Uttar Pradesh" ? updistricts : undefined}
                    label={t("LABEL_DISTRICT")}
                    placeholder={watchState(index) === "Uttar Pradesh" ? "Select District" : "Enter District"}
                    name={`landInfo.owners[${index}].correspondenceAddress.town`}
                    type={watchState(index) === "Uttar Pradesh" ? "searchSelect" : "textInput"}
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled
                  />
                </Col>
                {/* <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="District"
                    placeholder="Enter District"
                    name={`landInfo.owners[${index}].correspondenceAddress.town`}
                    type="textInput"
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col> */}
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="Communication Address"
                    placeholder="Enter Communication Address"
                    name={`landInfo.owners[${index}].correspondenceAddress.address`}
                    type="textInput"
                    mandatory
                    maxLength={150}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Address"),
                        message: "Please enter valid Address",
                      },
                    }}
                    disabled
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="Pin Code"
                    placeholder="Enter Pin Code"
                    name={`landInfo.owners[${index}].correspondenceAddress.pinno`}
                    type="number"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Pincode"),
                        message: "Please enter valid Pin Code",
                      },
                    }}
                    maxLength={6}
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="custom-upload new-custom-uploader signature-attach-uploader">
                    {!isEmployee && !isApproved && (
                      <FileUploader
                        control={control}
                        name="signature"
                        label="Attach Signature"
                        validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                        isMandatory
                        required
                        tab={2}
                        maxFiles={1}
                        showError={showError}
                      />
                    )}
                  </div>
                </Col>
                <Col></Col>
              </Row>
              <br />
            </Container>
          ))}

          <div className="footerContainer2">
            <div className="buttonWrapper">
              {!isEmployee && !isApproved && (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label={"Save"}
                  type="submit"
                  sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
                />
              )}
            </div>
            <ScrollButton />
          </div>
        </div>
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
